import styled from 'styled-components'
import {useState} from 'react'
import CardTitle from '../../../../common/styles/CardTitle'
import useTopAuthors from '../hooks/useTopAuthors'
import LoadingBar from '../../../../common/LoadingBar'
import NoContent from '../../../../common/NoContent'
import booksitoutIcon from '../../../../config/BooksitoutIcon'

const AuthorImage = ({src}: {src: string | null}) => {
	const [failed, setFailed] = useState(false)

	if (!src || failed) return (
		<ImagePlaceholder>
			<booksitoutIcon.user size={18} />
		</ImagePlaceholder>
	)
	return <Image src={src} alt={''} onError={() => setFailed(true)} />
}

const BookStatisticsTopAuthorsCard = () => {
	const [data, isLoading] = useTopAuthors()

	return (
		<Container>
				<CardTitle icon={null} mb={0} title={'작가 TOP 10'} url={''} textSize={5}/>

				{isLoading ? (
					<RankList>
						{Array.from({length: 10}).map((_, i) => (
							<LoadingItem key={i}>
								<Rank>{i + 1}</Rank>
								<LoadingImage/>
								<LoadingBar size={3}/>
							</LoadingItem>
						))}
					</RankList>
				) : data && data.authors.length > 0 ? (
					<RankList>
						{data.authors.map((item, index) => (
							<RankItem
								key={index}
								as={item.author.urlName ? 'a' : 'div'}
								href={item.author.urlName ? `/book/author/${item.author.urlName}` : undefined}
							>
								<Rank>{index + 1}</Rank>
								<AuthorImage src={item.author.imageUrl} />
								<Name className={'clamp-1-line'}>{item.author.name}</Name>
								<Count>{item.count}권</Count>
							</RankItem>
						))}
					</RankList>
				) : (
					<CenterContainer>
						<NoContent message={'데이터가 없어요'}/>
					</CenterContainer>
				)}
		</Container>
	)
}

const Container = styled.div`
	height: 100%;
	background-color: var(--card-bg-color);
	border-radius: 16px;
	border: 1px solid rgba(0, 0, 0, 0.06);
	box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.04);
	padding: 25px;
	display: flex;
	flex-direction: column;
`

const CenterContainer = styled.div`
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: center;
`

const LoadingItem = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 10px 8px;
	border-bottom: 1px solid var(--hover-bg-color);

	&:last-child {
		border-bottom: none;
	}
`

const LoadingImage = styled.div`
	width: 42px;
	height: 42px;
	border-radius: 50%;
	margin-right: 6px;
	background-color: var(--hover-bg-color);
`

const RankList = styled.div`
	display: flex;
	flex-direction: column;
`

const RankItem = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 10px 8px;
	border-bottom: 1px solid var(--hover-bg-color);
	text-decoration: none;
	color: inherit;

	&:last-child {
		border-bottom: none;
	}

	&:hover {
		background-color: var(--hover-bg-color);
	}
`

const Rank = styled.span`
	min-width: 24px;
	font-weight: bold;
	color: var(--sub-text-color);
	text-align: center;
`

const Image = styled.img`
	width: 42px;
	height: 42px;
	object-fit: cover;
	border-radius: 50%;
	margin-right: 6px;
`

const ImagePlaceholder = styled.div`
	width: 42px;
	height: 42px;
	border-radius: 50%;
	margin-right: 6px;
	background-color: var(--hover-bg-color);
	display: flex;
	align-items: center;
	justify-content: center;
	color: var(--sub-text-color);
`

const Name = styled.span`
	flex: 1;
	color: var(--text-color);
`

const Count = styled.span`
	color: var(--sub-text-color);
	font-size: 14px;
	white-space: nowrap;
`

export default BookStatisticsTopAuthorsCard
